type Props = {
  loadingState: "loading" | "ready" | "error";
  errorMessage: string | null;
  mailboxScanError?: string;
  isWaitingForRotationBatch: boolean;
  nextMailboxScanAt?: string;
};

const AdminKeysSecretsStatus = ({
  loadingState,
  errorMessage,
  mailboxScanError,
  isWaitingForRotationBatch,
  nextMailboxScanAt,
}: Props) => {
  if (loadingState === "loading") {
    return (
      <div
        data-test="admin-keys-secrets-loading"
        className="border-b border-[#D7E2DE] bg-[#F8FBFA] px-4 py-2 text-xs font-semibold text-[#4A5655]"
      >
        Loading mailbox messages...
      </div>
    );
  }

  if (loadingState === "error") {
    return (
      <div
        role="alert"
        data-test="admin-keys-secrets-error"
        className="border-b border-[#F59692] bg-[#FFEAED] px-4 py-2 text-xs font-semibold text-[#BF0002]"
      >
        {errorMessage ?? "Keys & Secrets could not be loaded."}
      </div>
    );
  }

  if (mailboxScanError) {
    return (
      <div
        role="alert"
        data-test="admin-keys-secrets-scan-error"
        className="border-b border-[#F59692] bg-[#FFEAED] px-4 py-2 text-xs font-semibold text-[#BF0002]"
      >
        {mailboxScanError}
      </div>
    );
  }

  if (isWaitingForRotationBatch) {
    return (
      <div
        role="status"
        data-test="admin-keys-secrets-waiting"
        className="border-b border-[#F5D48B] bg-[#FFF8E5] px-4 py-2 text-xs font-semibold text-[#6E5200]"
      >
        Waiting for all six key rotation emails.
        {nextMailboxScanAt ? ` Next mailbox scan: ${formatMailboxScanAt(nextMailboxScanAt)}.` : ""}
      </div>
    );
  }

  return null;
};

function formatMailboxScanAt(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default AdminKeysSecretsStatus;
